import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Category } from '~/core/enums';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import { ymGoal } from '~/core/utils/yandexReachGoal';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import { FavouritesApi } from '~/features/Favourites/api';
export var useFavourites = function useFavourites(payload) {
  var isLoadingFavourites = ref(false);
  var $snackbar = useMainSnackbarStore();
  var $router = useRouter();
  function sendMetricEvent(rateType) {
    if (rateType === Category.Doctor) {
      ymGoal('clickFavouritesDoctor');
      return;
    }
    if (rateType === Category.Lpu) {
      ymGoal('clickFavouritesClinic');
    }
  }
  function addToFavourites(_x, _x2, _x3) {
    return _addToFavourites.apply(this, arguments);
  }
  function _addToFavourites() {
    _addToFavourites = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id, type, successMessage) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isLoadingFavourites.value = true;
            _context.prev = 1;
            _context.next = 4;
            return FavouritesApi.add(type, id, payload.familyProfileUuid);
          case 4:
            sendMetricEvent(type);
            payload.afterAddToFavourites();
            successMessage === null || successMessage === void 0 ? void 0 : successMessage();
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            $snackbar.open(CORE_SNACKBAR.ERROR_WITH_RELOAD);
          case 12:
            _context.prev = 12;
            isLoadingFavourites.value = false;
            return _context.finish(12);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9, 12, 15]]);
    }));
    return _addToFavourites.apply(this, arguments);
  }
  function showRemoveFromFavouritesSnackbar(id, type) {
    $snackbar.open(_objectSpread(_objectSpread({}, CORE_SNACKBAR.FAVOURITES_DELETED), {}, {
      cancelHandler: function cancelHandler() {
        addToFavourites(id, type, function () {
          $snackbar.open(CORE_SNACKBAR.RESTORED);
        });
      }
    }));
  }
  function removeFromFavourites(_x4, _x5) {
    return _removeFromFavourites.apply(this, arguments);
  }
  function _removeFromFavourites() {
    _removeFromFavourites = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, type) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isLoadingFavourites.value = true;
            _context2.prev = 1;
            _context2.next = 4;
            return FavouritesApi.delete(type, id);
          case 4:
            payload.afterRemoveFromFavourites();
            showRemoveFromFavouritesSnackbar(id, type);
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            $snackbar.open(CORE_SNACKBAR.ERROR_WITH_RELOAD);
          case 11:
            _context2.prev = 11;
            isLoadingFavourites.value = false;
            return _context2.finish(11);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 8, 11, 14]]);
    }));
    return _removeFromFavourites.apply(this, arguments);
  }
  function showAddToFavouritesSnackbar() {
    $snackbar.open(_objectSpread(_objectSpread({}, CORE_SNACKBAR.FAVOURITES_ADDED), {}, {
      cancelHandler: function cancelHandler() {
        $router.push({
          name: 'favourites'
        });
      }
    }));
  }
  function handleClickFavourites(id, type, isFavourites) {
    if (isFavourites) {
      removeFromFavourites(id, type);
      return;
    }
    addToFavourites(id, type, showAddToFavouritesSnackbar);
  }
  return {
    isLoadingFavourites: isLoadingFavourites,
    addToFavourites: addToFavourites,
    removeFromFavourites: removeFromFavourites,
    handleClickFavourites: handleClickFavourites,
    showAddToFavouritesSnackbar: showAddToFavouritesSnackbar
  };
};